// Extrai só o texto de uma string HTML (descrição vinda do Quill), para exibir
// com line-clamp nos cards mobile sem risco de XSS (não renderiza o HTML).
export default function stripHtml(html: string | null | undefined): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
